/** Roles that may open the admin interface at all. */
export const STAFF_ROLES = ['admin', 'marketer'];
/** Whether a role reaches the admin interface (the advisor or a marketer). */
export function isStaffRole(role) {
    return role === 'admin' || role === 'marketer';
}
